export enum UserRole {
  POSTULANTE = 'Postulante',
  ADMINISTRADOR = 'Administrador',
}
